module.exports = __webpack_public_path__ + "static/media/Email.db923c82.svg";